// @ts-nocheck

if (!customElements.get("custom-file-upload")) {
  class CustomFileUpload extends HTMLElement {
    connectedCallback() {
      // add a 2s delay in initializiang this component

      setTimeout(() => {
        this.fileUpload = this.querySelector("#upload-file");
        this.preview = this.querySelector(".file__preview");
        // this.hiddenInput = this.querySelector(
        //   'input[name="properties[Uploaded Picture]"]'
        // );
        this.fileLabel = this.querySelector(".filelabel");
        this.addToCartButton = this.closest("quick-add-dialog")
          ? this.closest("quick-add-dialog").querySelector(
              ".add-to-cart-button"
            )
          : document.querySelector(".add-to-cart-button");
        this.stickyAddToCartButton = document.querySelector(
          ".cart-sticky-bar .add-to-cart-button"
        );
        this.addToCartComponent = document.querySelector(
          "add-to-cart-component"
        );
        this.stickyAddToCartComponent = document.querySelector(
          ".cart-sticky-bar add-to-cart-component"
        );

        if (!this.fileUpload || !this.addToCartButton) return;

        this.setATCButton(true);
        // Disable add-to-cart button initially

        this.fileUpload.addEventListener(
          "change",
          this.handleChange.bind(this)
        );
      }, 1000);
    }

    setATCButton(disabled = true) {
      if (disabled) {
        this.addToCartButton.disabled = true;
        this.addToCartButton.style.opacity = "0.5";
        this.addToCartButton.style.cursor = "not-allowed";
        this.addToCartComponent.disable();

        if (this.stickyAddToCartButton) {
          this.stickyAddToCartButton.disabled = true;
          this.stickyAddToCartButton.style.opacity = "0.5";
          this.stickyAddToCartButton.style.cursor = "not-allowed";
          this.stickyAddToCartButton.style.pointerEvents = "none";
          this.stickyAddToCartComponent.disable();
        }
      } else {
        // Enable add-to-cart button
        this.addToCartButton.disabled = false;
        this.addToCartButton.style.opacity = "1";
        this.addToCartButton.style.cursor = "pointer";
        this.addToCartComponent.enable();

        if (this.stickyAddToCartButton) {
          this.stickyAddToCartButton.disabled = false;
          this.stickyAddToCartButton.style.opacity = "1";
          this.stickyAddToCartButton.style.cursor = "pointer";
          this.stickyAddToCartButton.style.pointerEvents = "auto";
          this.stickyAddToCartComponent.enable();
        }
      }
    }

    handleChange(e) {
      const file = e.target.files[0];
      console.log("file", file);
      if (!file) return;

      // Clear previous preview
      this.preview.innerHTML = "";

      const fileReader = new FileReader();
      fileReader.addEventListener("load", (e) => {
        const div = document.createElement("div");
        div.classList.add("file__preview_item");
        div.innerHTML = `
                <img class="file__preview-thumb" src="${e.target.result}" title="${file.name}" />
                <span class="file__remove-btn">x</span>
                `;

        div.innerHTML = `
                    <dialog-component class="popup-link">
                        <button
                            on:click="/showDialog"
                            class="button button-unstyled popup-link__button text-left spacing-style body"
                        >
                            <img class="file__preview-thumb" src="${e.target.result}" title="${file.name}" />
                            </button>
                            <span class="file__remove-btn">x</span>

                        <dialog
                            ref="dialog"
                            class="popup-link__content dialog-modal color-1 "
                            style="width: 100%; height: 100%; --normal-content-width: 60rem; --modal-max-height: 90dvh;"
                            scroll-lock
                        >
                            <div class="popup-link__inner">
                            <img class="file__preview-thumb" src="${e.target.result}" title="${file.name}" style="width: 100%; height: 100%;" />
                            </div>
                            <button
                                ref="closeButton"
                                on:click="/closeDialog"
                                class="button button-unstyled close-button popup-link__close"
                                aria-label="{{ 'accessibility.close_dialog' | t }}"
                            >
                            {{- 'icon-close.svg' | inline_asset_content -}}
                            </button>
                        </dialog>
                    </dialog-component>
                    `;

        console.log("this.preview", this.preview);
        this.preview.append(div);

        // Update hidden input for Shopify
        // this.hiddenInput.value = e.target.result;
        // this.hiddenInput.value = file.name;

        // Disable upload button
        // this.fileUpload.disabled = true;
        this.fileLabel.style.opacity = "0.5";

        this.setATCButton(false);
        // Remove button logic
        div.querySelector(".file__remove-btn").addEventListener("click", () => {
          this.preview.innerHTML = "";
          this.fileUpload.value = "";
          // this.hiddenInput.value = "No";

          // Re-enable upload button
          this.fileUpload.disabled = true;
          this.fileLabel.style.opacity = "1";

          this.setATCButton(true);
        });
      });
      fileReader.readAsDataURL(file);
    }
  }
  customElements.define("custom-file-upload", CustomFileUpload);
}
